import { Component, Inject, OnInit, ChangeDetectorRef} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { DrakeViewStandardComponent } from '../drake-view-standard/drake-view-standard.component';
import { DrakeViewWizardComponent } from '../drake-view-wizard/drake-view-wizard.component';
import { DrakeViewKpiComponent } from '../drake-view-kpi/drake-view-kpi.component';
import { DrakeScopeFormComponent } from '../drake-scope-form/drake-scope-form.component';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { forEach } from 'lodash';
import { IconsModule } from '@progress/kendo-angular-icons';
import { TranslocoModule, TranslocoPipe } from '@ngneat/transloco';



@Component({
  selector: 'app-drake-matrix-edit',
  templateUrl: './drake-matrix-edit.component.html',
  styleUrls: ['./drake-matrix-edit.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DrakeViewStandardComponent,
    DrakeViewWizardComponent,
    DrakeViewKpiComponent,
    IconsModule,
    TranslocoModule,
  ],
  providers: [DatePipe, TranslocoPipe],
  standalone: true
})
export class DrakeMatrixEditComponent implements OnInit {
  viewConfig:any = {}
  baseData:any = {};
  header: string = "";
  

  fieldConfig: any = {};  
  public readonly:boolean = false;

    constructor(

    public dialogRef: MatDialogRef<DrakeMatrixEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
      private datePipe: DatePipe, // Inietta DatePipe per formattare le date
      private cdr: ChangeDetectorRef,
      private drakeSharedService: DrakeSharedService
    ) {

    this.viewConfig = data.viewConfig;
    this.fieldConfig = data.fieldConfig;
    this.baseData = {};
    this.baseData[data.scope] = {};
    this.baseData[data.scope][data.item?._id||"#NEWID#"] = data.item;
    this.header = data.header;

  }

  ngOnInit(): void {
    

    }

    onChange(item: any): void {
        //console.log('Modifiche rilevate:', item);
       // this.baseData[this.data.scope][this.data.item._id || "#NEWID#"] = { ...this.data.item, ...item };
    }


  onNoClick(): void {
    this.dialogRef.close();
  }

    onSaveClick(): void {

        // Pulisci il FieldMatrix rimuovendo eventuali array vuoti
        this.cleanMatrixData(this.baseData);  
        const data = this.baseData;
        const recordId = this.data.item._id;
        this.baseData[this.data.scope][recordId] = this.data.item;

        this.dialogRef.close({ result: data });
    }

    cleanMatrixData(data: any): void {
        Object.keys(data).forEach(scope => {
            Object.keys(data[scope]).forEach(recordId => {
                const record = data[scope][recordId];
                if (record.FieldMatrix) {
                    record.FieldMatrix = record.FieldMatrix.filter((item: any) => {
                        return Object.keys(item).length > 0;
                    });
                }
            });
        });
    }

    



}
